import { TileLayer } from "react-leaflet";

// Base maps for the Leaflet maps (Radar, Review, position picker).
// Google tiles come straight from Google's tile server: lyrs=r road map, lyrs=y satellite + labels.
const GOOGLE_KEY = "AIzaSyBpAz6H-5sK4Yqre9BanVuZKFgk0ndOmHI";
export const googleTiles = (layer) =>
  `https://mt1.google.com/vt/lyrs=${layer}&x={x}&y={y}&z={z}&key=${GOOGLE_KEY}`;

export const MAP_TYPES = {
  roadmap: {
    label: "Map",
    url: googleTiles("r"),
    attribution: '&copy; <a href="https://www.google.com/maps">Google Maps</a>',
  },
  satellite: {
    label: "Satellite",
    url: googleTiles("y"),
    attribution: '&copy; <a href="https://www.google.com/maps">Google Maps</a>',
  },
  osm: {
    label: "OSM",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>',
  },
};

// key: a different url must replace the layer, react-leaflet doesn't swap it in place
const BaseMapLayer = ({ type = "roadmap" }) => {
  const t = MAP_TYPES[type] || MAP_TYPES.roadmap;
  return <TileLayer key={type} url={t.url} attribution={t.attribution} />;
};

export default BaseMapLayer;
